<!-- 不良事件报告 -->
<template>
  <div class='page_content'>
    <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
      <xsbadnessReportAction v-if="showStatus" ref="xsbadnessReportAction" @drawerCancel="drawerCancel" :actionData="actionData"></xsbadnessReportAction>
    </el-drawer>
    <div class="page_content_top">
        <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" ></v-button>
      <div class="page_content_top_line">
        <el-form label-width="100px" :inline="true" :model="getRequestData" class="demo-form-inline" size="mini">
          <el-form-item>
            <label slot="label" :style="$common.labelStyle('患者姓名')" v-html="$common.htmlLabel('患者姓名')"></label>
            <el-input size="mini" class="form_codition" v-model="getRequestData.patientName"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" @click="searchData">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="page_content_center">
      <el-table class="table1" :data="returnData.list" :height="tableHeight" border style="width: 100%" highlight-current-row size="mini">
        <el-table-column label="选择操作" width="80">
          <template slot-scope="scope">
            <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
              <i class="el-icon-thumb"></i>
            </el-radio>
          </template>
        </el-table-column>
        <el-table-column v-for="(item, index) in fieldJsonList" :key="index" show-overflow-tooltip align="center" :min-width="item.fieldWeight" :prop="item.entityField" :label="item.showField">
          <template slot-scope="scope">
            <span v-if="item.fieldType == 'date'">
              <span v-if="scope.row[item.entityField]">
                {{ scope.row[item.entityField] ? $common.getLocalTime(+scope.row[item.entityField]) : '' }}
              </span>
            </span>
            <el-tag size="mini" v-else-if="item.fieldType == 'formatter'">{{ getIsGsp(item.formatterContent,
                            scope.row[item.entityField]) }}</el-tag>
            <span v-else>
              {{ scope.row[item.entityField] }}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page_content_bottom">
      <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../byComponents/SearchScheme.vue"
import xsbadnessReportAction from '@/components/xsbadnessReportAction.vue'
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { SearchScheme, xsbadnessReportAction, },
  data() {
    //这里存放数据
    return {
      showStatus: false,
      tableHeight: 0,
      getRequestData: {
        "businessId": "",
        "cmName": "",
        ormId: JSON.parse(sessionStorage.getItem("loginInfo")).ormId,//	组织ID
        "end": '',
        "page": 1,
        "rows": 30,
        "start": '',
        // "status": 0,
        "wobkemId": ""
      },
      returnData: {
        list: []
      },
      fieldJsonList: [
        {
          entityField: 'patientName',
          fieldWeight: '120',
          showField: '患者姓名',
          fieldType: 'string',
        },
        {
          entityField: 'patientSex',
          fieldWeight: '120',
          showField: '性别',
          fieldType: 'string',
        },
        {
          entityField: 'patientBirthday',
          fieldWeight: '120',
          showField: '出生日期',
          fieldType: 'date',
        },
        {
          entityField: 'patientNation',
          fieldWeight: '120',
          showField: '民族',
          fieldType: 'string',
        },
        {
          entityField: 'badnessName',
          fieldWeight: '120',
          showField: '不良事件名称',
          fieldType: 'string',
        },
        {
          entityField: 'badnessTime',
          fieldWeight: '120',
          showField: '不良事件发生时间',
          fieldType: 'date',
        },
        {
          entityField: 'expression',
          fieldWeight: '220',
          showField: '不良事件的表现（包括临床检验）',
          fieldType: 'string',
        },
        {
          entityField: 'handSituation',
          fieldWeight: '160',
          showField: '不良事件处理情况',
          fieldType: 'string',
        },
        {
          entityField: 'useSituation',
          fieldWeight: '120',
          showField: '医疗器械使用情况',
          fieldType: 'string',
        },
        {
          entityField: 'diagnoseSituation',
          fieldWeight: '120',
          showField: '患者诊治情况',
          fieldType: 'string',
        },
        {
          entityField: 'reportTime',
          fieldWeight: '120',
          showField: '报告日期及时间',
          fieldType: 'date',
        },
        {
          entityField: 'createTime',
          fieldWeight: '120',
          showField: '创建时间',
          fieldType: 'date',
        },
        {
          entityField: 'createrName',
          fieldWeight: '120',
          showField: '创建人',
          fieldType: 'string',
        },
      ],
      list: [],
      buttonList: [],
      selectedDataIndex: 0,
      actionData: {},
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
  },
  //方法集合
  methods: {
    async getPageInfo() {
      var pathId = parent.getMenuInfo(this.$route.path)
      let responseData = await this.$http.getJur({ ids: [pathId.jurId] })
      if (responseData.status == 200) {
        this.getButtonList()
        this.getDataList()
      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }
    },
    getIsGsp(val, list) {

    },
    // 动作集合
    actionSet(actionData) {
      console.log(actionData.actionType);
      switch (actionData.actionType) {
        case 0:
          this.actionData = {
            cate: 0,
            oldData: '',
            orderId: '',
            printSouce: '',
            printJurId: '',
          }
          this.showStatus = true
          break;
        case 1:
          if (this.returnData.list.length <= 0) {
            this.$message({
              message: '暂无数据',
              type: 'error'
            });
            return false
          }
          this.actionData = {
            cate: 1,
            oldData: this.returnData.list[this.selectedDataIndex],
            orderId: '',
            printSouce: '',
            printJurId: '',
          }
          console.log(this.returnData.list[this.selectedDataIndex]);
          this.showStatus = true
          break;
        case 2:
          if (this.returnData.list.length <= 0) {
            this.$message({
              message: '暂无数据',
              type: 'error'
            });
            return false
          }
          this.delData()
          break;
        case 3:
          if (this.returnData.list.length <= 0) {
            this.$message({
              message: '暂无数据',
              type: 'error'
            });
            return false
          }
          this.actionData = {
            cate: 2,
            oldData: this.returnData.list[this.selectedDataIndex],
            orderId: '',
            printSouce: '',
            printJurId: '',
          }
          this.showStatus = true
          break;
      }
    },
    // 数据搜索
    searchData() {
      this.getRequestData.page = 1
      this.getDataList()
    },
    drawerCancel() {
      this.showStatus = false
      this.getDataList()
    },
    // 数据翻页
    setDataPageNumber(val) {
      this.getRequestData.page = val
      this.getDataList()
    },

    // 切换显示条数
    setDataPageSize(val) {
      this.getRequestData.page = 1
      this.getRequestData.rows = val
      this.getDataList()
    },
    delData() {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.deleteBadness({
          ids: [this.returnData.list[this.selectedDataIndex].bmId]
        }).then(res => {
          if (res.status == 200) {
            this.getDataList()
            this.$message({
              message: "删除成功",
              type: "success",
            });
          } else {
            this.$message.error(res.message)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },

    // 获取数据列表
    async getDataList() {
      let responseData = await this.$http.queryBadness(this.getRequestData)
      if (responseData && responseData.status == 200) {
        let resData = JSON.parse(JSON.stringify(responseData))
        this.returnData.list = resData.result.list
        this.returnData.pages = resData.result.pages
        this.returnData.total = resData.result.total
        this.returnData.pageNum = resData.result.pageNum
        this.selectedDataIndex = 0

      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }
    },

    // 获取按钮权限
    async getButtonList() {
      this.buttonList = await this.$common.getActionButton()
      
    },
    initTime() {
      this.getRequestData.start = this.$common.getStartTime()
      this.getRequestData.end = this.$common.getEndTime()
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getPageInfo()
    this.initTime()
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style  scoped>
.table_content_tag {
  margin-right: 1rem;
}

.el-tabs--border-card_new {
  height: 85vh;
  overflow-y: scroll;
}

::v-deep .table1 tr td:first-child .cell,
::v-deep .table1 tr th:first-child .cell {
  text-align: center;
}

::v-deep .table1 .el-checkbox__inner {
  width: 18px;
  height: 18px;
}

::v-deep .table1 .el-checkbox__inner::after {
  height: 8px;
  left: 6px;
  top: 2px;
  width: 5px;
}

::v-deep
  .table1
  .el-checkbox__input.is-indeterminate
  .el-checkbox__inner::before {
  height: 2px;
  left: 0;
  right: 0;
  top: 7px;
}
</style>
